import Config from "../../config/index";

const initialState = {

    isLoggedIn: false,
    email: 'info@awave.se',
    id:null,
    guid:null,
    userName:"",
    userId:"",
    firstName: null,
    lastName: null,
    loading:false,
    submitting:false,
    ssoGetTokenLoading:false,
    ssoGetTokenFailed:false,
    ssoToken:"",
    ssoFailedCounter:0,
};

export default (state = initialState, action) => {

    switch (action.type) {

        case "USER_RESET":
            return initialState;

        case 'USER_LOGIN_SUBMITTING':
            state={
                ...state,
                submitting:true
            };
            return state;
            
        case 'USER_LOGIN_SUCCESS':
            state={
                ...state,
                userName:action.payload.userName,
                userId:action.payload.userId,
                guid:action.payload.guid,
                isLoggedIn:true,
                submitting:false,
                loading:false
            };
            return state;
            
        case 'USER_LOGIN_FAILURE':
            state={
                ...initialState,
                username:"",
                userId:"",
                isLoggedIn:false,
                submitting:false,
                loading:false
            };
            return state;
            
        case "USER_SET_ACTION_KEYWORD":
            state = {
                ...state,
                actionSearchKeyword:action.payload
            };
            return state;

        case 'USER_LOADING':
            state = {
                ...state,
                loading:true
            }
            return state;

        case 'USER_SINGLE_SUCCESS':

            Config.setUser({
                guid:action.payload.guid,
                userId:action.payload.userId,
                userName:action.payload.username,
            });

            state = {
                ...state,
                ...action.payload,
                manager:null,
                ongoingActions:null,
                actionGroups:null,
                loading:false,
                manageAs:null,
                managers:null
            }
            return state;

        case 'USER_SINGLE_FAILURE':
            state = {
                ...state,
                manager:null,
                ongoingActions:null,
                actionGroups:null,
                loading:false
            };
            return state;

        //---SSO-TOKEN
        case "SSO_GET_TOKEN_LOADING":
            state={
                ...state,
                ssoGetTokenLoading:true,
                ssoTest:false,
                ssoGetTokenFailed:false
            };
            return state;

        case "SSO_GET_TOKEN_SUCCESS":
            state={
                ...state,
                ssoGetTokenLoading:false,
                ssoToken:action.payload,
                ssoGetTokenFailed:false,
                ssoFailedCounter:0,
            };
            return state;

        case "SSO_GET_TOKEN_FAILURE":
            state={
                ...state,
                ssoGetTokenLoading:false,
                ssoGetTokenFailed:true,
                ssoToken:false,
                ssoFailedCounter:state.ssoFailedCounter+1,
            };
            return state;

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/store/reducers/user.js